<template>
    <v-container grid-list-xl fluid>
        <v-layout row wrap>
            <v-flex lg12>
                <v-card>
                    <hpo-filter :headers="filter_header" :viewName="viewName" :view_filters="view_filters"
                        v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                    <v-row v-if="selectedItems && selectedItems.length > 0" class="mb-2 ml-1">
                        <v-col cols="auto" v-if="currentPath.includes('nhap-kho-tq') && !roleStoreTQ">
                            <v-btn color="primary" @click="changeStatusSelectedProducts">
                                <v-icon left>mdi-sync</v-icon>
                                Chuyển trạng thái ({{ selectedItems.length }})
                            </v-btn>
                        </v-col>
                        <!-- <v-col cols="auto">
                            <v-btn color="success" @click="exportSelectedItems">
                                <v-icon left>mdi-download</v-icon>
                                Xuất Excel ({{ selectedItems.length }})
                            </v-btn>
                        </v-col> -->
                        <v-col cols="auto">
                            <v-chip color="blue" text-color="white" small>
                                <v-icon left small>mdi-package-variant-closed</v-icon>
                                {{ selectedItemsNumberOfPack | currency }} kiện
                            </v-chip>
                        </v-col>
                        <v-col cols="auto">
                            <v-chip color="orange" text-color="white" small>
                                <v-icon left small>mdi-weight-kilogram</v-icon>
                                {{ selectedItemsWeight | currency('', 1) }} kg
                            </v-chip>
                        </v-col>
                        <v-col cols="auto">
                            <v-chip color="green" text-color="white" small>
                                <v-icon left small>mdi-cube-outline</v-icon>
                                {{ selectedItemsVolume | currency('', 3) }} m³
                            </v-chip>
                        </v-col>
                    </v-row>
                    <v-data-table :headers="headers" :items="items" :options.sync="pagination"
                        :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true"
                        :loading="loading" :mobile-breakpoint="100" show-select item-key="ID" v-model="selectedItems">
                        <template v-slot:item="{ item, isSelected, select }">
                            <tr :active="isSelected" :id="'r-' + item.ID">
                                <td @click="select(!isSelected)"><v-checkbox primary hide-details
                                        :input-value="isSelected"></v-checkbox></td>
                                <td>{{ item.CustomerCode }}</td>
                                <td>{{ item.DirectName }}</td>
                                <td>{{ item.ProductNameVN }}</td>
                                <td>{{ item.Code }}</td>
                                <td>
                                    <p v-html="item.OrderCodes"></p>
                                </td>
                                <td>
                                    <p v-html="item.BillCodes"></p>
                                </td>
                                <td class="text-right">
                                    <v-tooltip right color="grey lighten-3" transition="expand-transition">
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on" v-if="currentPath.includes('ton-kho-tq')">{{
                                                ((item.NumberOfPack | 0) -(item.NumberOfPackTruck | 0)) | currency
                                                }}</span>
                                            <span v-on="on" v-else-if="currentPath.includes('ton-kho-vn')">{{
                                                ((item.NumberOfPackImport | 0) -(item.NumberOfPackExport | 0)) | currency
                                                }}</span>
                                            <span v-on="on" v-else>{{ item.NumberOfPack | currency }}</span>
                                        </template>
                                        <span>
                                            <v-list width="350" color="transparent">
                                                <v-list-item>
                                                    <v-list-item-title>Tổng kiện: </v-list-item-title>
                                                    <v-list-item-subtitle>{{ item.NumberOfPack |
                                                        currency}}</v-list-item-subtitle>
                                                </v-list-item>
                                                <v-list-item>
                                                    <v-list-item-title>Đã xếp xe: </v-list-item-title>
                                                    <v-list-item-subtitle>{{ item.NumberOfPackTruck |
                                                        currency}}</v-list-item-subtitle>
                                                </v-list-item>
                                                <v-list-item>
                                                    <v-list-item-title>Nhập kho VN: </v-list-item-title>
                                                    <v-list-item-subtitle>{{ item.NumberOfPackImport |
                                                        currency}}</v-list-item-subtitle>
                                                </v-list-item>
                                                <v-list-item>
                                                    <v-list-item-title>Xuất kho VN: </v-list-item-title>
                                                    <v-list-item-subtitle>{{ item.NumberOfPackExport |
                                                        currency}}</v-list-item-subtitle>
                                                </v-list-item>
                                            </v-list>
                                        </span>
                                    </v-tooltip>
                                </td>
                                <td class="text-right">
                                    <v-tooltip right color="grey lighten-3" transition="expand-transition">
                                        <template v-slot:activator="{ on }">
                                            <p v-on="on" :style="{'color': item.Deposit ? 'rgb(32, 165, 58)' : ''}">{{ item.Deposit | currency('', 2) }}</p>
                                            <p style="font-size: 11px;">{{ (item.Deposit * item.ExchangeRate) | currency }}</p>
                                        </template>
                                        <span>
                                            <v-list width="350" color="transparent">
                                                <v-list-item>
                                                    <v-list-item-title>Ship nội địa: </v-list-item-title>
                                                    <v-list-item-subtitle>{{ item.TransactionDeposit | currency('¥',
                                                        1)}}</v-list-item-subtitle>
                                                </v-list-item>
                                                <v-list-item>
                                                    <v-list-item-title>Chi xe kéo: </v-list-item-title>
                                                    <v-list-item-subtitle>{{ item.PedicabDeposit | currency('¥',
                                                        1)}}</v-list-item-subtitle>
                                                </v-list-item>
                                                <v-list-item>
                                                    <v-list-item-title>Chi xe nâng: </v-list-item-title>
                                                    <v-list-item-subtitle>{{ item.LoadDeposit | currency('¥',
                                                        1)}}</v-list-item-subtitle>
                                                </v-list-item>
                                                <v-list-item>
                                                    <v-list-item-title>Phí đóng gỗ: </v-list-item-title>
                                                    <v-list-item-subtitle>{{ item.ReinforceDeposit | currency('¥',
                                                        1)}}</v-list-item-subtitle>
                                                </v-list-item>
                                            </v-list>
                                        </span>
                                    </v-tooltip>
                                </td>
                                <td class="text-right">
                                    <span>{{ item.Weight | currency('', 1) }} kg</span>
                                    <br />
                                    <span>{{ item.Volume | currency('', 3) }} m³</span>
                                    <br />
                                    <span style="font-size: 11px;color:gray">{{ item.Weight/item.Volume | currency('', 3) }} kg</span>
                                </td>
                                <td class="text-right">
                                    <span>{{ item.TotalFeeWeight | currency }}</span>
                                    <br />
                                    <span style="font-size: 11px;" :style="{'color': item.TotalPaid ? 'rgb(32, 165, 58)' : ''}">{{ item.TotalPaid | currency }}</span>
                                </td>
                                <td>
                                    {{ item.ReceiveDate | display_date('DD-MM-YYYY') }}
                                    <br />
                                    {{ item.PackDate | display_date('DD-MM-YYYY') }}
                                </td>
                                <td>
                                    {{ item.StoreCNExpDate | display_date('DD-MM-YYYY') }}
                                    <br />
                                    {{ item.PaymentDate | display_date('DD-MM-YYYY') }}
                                </td>
                                <td v-if="editableRole && item.Status != product_status.xuat_du">
                                    <v-edit-dialog :return-value.sync="item.Status" large lazy persistent
                                        @save="saveItem({ ID: item.ID, Status: item.Status }, item.Status)">
                                        <div>{{ item.Status | display_value(product_status_list) }}</div>
                                        <template v-slot:input>
                                            <v-select v-model="item.Status" :items="product_status_list"
                                                :item-text="p => p.i18n ? $t(p.i18n) : p.name" item-value="value" :label="$t('form.status')" class="ma-1">
                                            </v-select>
                                        </template>
                                    </v-edit-dialog>
                                </td>
                                <td v-else>{{ item.Status | display_value(product_status_list) }}</td>
                                <td v-if="editableRole">
                                    <v-edit-dialog :return-value.sync="item.ProductType" large lazy persistent
                                        @save="saveItem({ ID: item.ID, ProductType: item.ProductType }, item.Status)">
                                        <div>{{ item.ProductType | display_value(product_types, 'ID', 'Name') }}</div>
                                        <template v-slot:input>
                                            <v-select v-model="item.ProductType" :items="filteredProductTypes"
                                                :item-text="u => `${u.ShortName}-${u.Name}`" item-value="ID" class="ma-1">
                                            </v-select>
                                        </template>
                                    </v-edit-dialog>
                                </td>
                                <td v-else>{{ item.ProductType | display_value(product_types, 'ID', 'Name') }}</td>
                                <td class="text-center">
                                    <v-menu offset-y>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon v-bind="attrs" v-on="on">
                                                <v-icon>mdi-dots-vertical</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-item @click="openItem(item.ID)">
                                                <v-list-item-icon>
                                                    <v-icon>{{ !editableRole ? 'visibility' : 'edit' }}</v-icon>
                                                </v-list-item-icon>
                                                <v-list-item-title>{{ !editableRole ? $t('actions.view') : $t('actions.edit') }}</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item :disabled="!(editableRole || item.Status == product_status.nhap_kho_tq)" @click="deleteItem(item.ID)">
                                                <v-list-item-icon>
                                                    <v-icon>delete</v-icon>
                                                </v-list-item-icon>
                                                <v-list-item-title>{{ $t('actions.delete') }}</v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </td>
                            </tr>
                        </template>
                        <template slot="body.append">
                            <tr v-if="summary" class="total-summary-td">
                                <td colspan="7" class="text-center font-weight-bold">Tổng</td>
                                <td class="text-end font-weight-bold">{{ summary.NumberOfPack | currency('', 2) }}</td>
                                <td class="text-end font-weight-bold">{{ summary.Deposit | currency('', 2) }}</td>
                                <td class="text-end font-weight-bold">
                                    <span>{{ summary.Weight | currency('', 1) }} kg</span>
                                    <br/>
                                    <span>{{ summary.Volume | currency('', 3) }} m³</span>
                                </td>
                                <td class="text-end font-weight-bold">{{ summary.TotalFeeWeight | currency }}</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="dialogItem" max-width="800px">
            <v-form ref="edit_form" lazy-validation>
                <v-card>
                    <v-card-actions>
                        <span class="title">Chi tiết mã bốc</span>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1 white--text" @click="dialogItem = false">{{ $t('actions.close') }}</v-btn>
                        <v-btn @click="editItem" v-if="editableRole">{{ $t('actions.save') }}</v-btn>
                    </v-card-actions>
                    <v-card-text>
                        <v-container grid-list-md pa-0>
                            <v-layout row wrap>
                                <v-flex lg12>
                                    <v-text-field outlined dense label="Mã bốc" v-model="currentItem.SuffixBill"></v-text-field>
                                </v-flex> 
                                <v-flex lg12 md12 sm12 v-if="editableRole">
                                    <v-layout row wrap justify-end>
                                        <v-btn class="mx-2" dark small color="red" @click="addSubItem"
                                            :disabled="readOnly"><v-icon dark>add</v-icon></v-btn>
                                    </v-layout>
                                </v-flex>
                                <v-layout pt-2>
                                    <v-flex lg12 md12 sm12>
                                        <v-data-table :must-sort="false" :headers="sub_headers" :items="currentPackages"
                                            hide-default-footer disable-pagination>
                                            <template v-slot:item="{ item, index }">
                                                <tr>
                                                    <td class="truncate" v-if="readOnly">{{ item.TransactionCode }}</td>
                                                    <td class="truncate" v-else>
                                                        <v-edit-dialog :return-value.sync="item.Length" large lazy
                                                            @save="updateSubItem(true)">
                                                            <div>{{ item.TransactionCode }}</div>
                                                            <template v-slot:input>
                                                                <v-text-field v-model="item.TransactionCode" :label="$t('form.suffix_bill')"
                                                                    autofocus></v-text-field>
                                                            </template>
                                                        </v-edit-dialog>
                                                    </td>
                                                    <td class="text-end" v-if="readOnly">{{ item.Length | currency }}</td>
                                                    <td class="text-end" v-else>
                                                        <v-edit-dialog :return-value.sync="item.Length" large lazy
                                                            @save="updateSubItem">
                                                            <div>{{ item.Length | currency }}</div>
                                                            <template v-slot:input>
                                                                <h-currency-input v-model="item.Length" :autoEmit="true"
                                                                    :decimal="0" :label="$t('form.length') + '(cm)'"
                                                                    autofocus></h-currency-input>
                                                            </template>
                                                        </v-edit-dialog>
                                                    </td>
                                                    <td class="text-end" v-if="readOnly">{{ item.Width | currency }}</td>
                                                    <td class="text-end" v-else>
                                                        <v-edit-dialog :return-value.sync="item.Width" large lazy
                                                            @save="updateSubItem">
                                                            <div>{{ item.Width | currency }}</div>
                                                            <template v-slot:input>
                                                                <h-currency-input v-model="item.Width" :autoEmit="true"
                                                                    :decimal="0" :label="$t('form.width') + '(cm)'"
                                                                    autofocus></h-currency-input>
                                                            </template>
                                                        </v-edit-dialog>
                                                    </td>
                                                    <td class="text-end" v-if="readOnly">{{ item.Height | currency }}</td>
                                                    <td class="text-end" v-else>
                                                        <v-edit-dialog :return-value.sync="item.Height" large lazy
                                                            @save="updateSubItem">
                                                            <div>{{ item.Height | currency }}</div>
                                                            <template v-slot:input>
                                                                <h-currency-input v-model="item.Height" :autoEmit="true"
                                                                    :decimal="0" :label="$t('form.height') + '(cm)'"
                                                                    autofocus></h-currency-input>
                                                            </template>
                                                        </v-edit-dialog>
                                                    </td>
                                                    <td class="text-end" v-if="readOnly">{{ item.Weight | currency('', 1) }}
                                                    </td>
                                                    <td class="text-end" v-else>
                                                        <v-edit-dialog :return-value.sync="item.Weight" large lazy
                                                            @save="updateSubItem">
                                                            <div>{{ item.Weight | currency('', 1) }}</div>
                                                            <template v-slot:input>
                                                                <h-currency-input v-model="item.Weight" :autoEmit="true"
                                                                    :decimal="1" :label="$t('form.weight') + '(kg)'"
                                                                    autofocus></h-currency-input>
                                                            </template>
                                                        </v-edit-dialog>
                                                    </td>
                                                    <td class="text-end" v-if="readOnly">{{ item.NumberOfPack | currency }}
                                                    </td>
                                                    <td class="text-end" v-else>
                                                        <v-edit-dialog :return-value.sync="item.NumberOfPack" large lazy
                                                            @save="updateSubItem">
                                                            <div>{{ item.NumberOfPack | currency }}</div>
                                                            <template v-slot:input>
                                                                <h-currency-input v-model="item.NumberOfPack"
                                                                    :autoEmit="true" :decimal="0" :label="$t('form.number_of_pack')"
                                                                    autofocus></h-currency-input>
                                                            </template>
                                                        </v-edit-dialog>
                                                    </td>
                                                    <td class="text-center">
                                                        <v-icon small @click="deleteSubItem(index)"
                                                            v-if="!readOnly">delete</v-icon>
                                                    </td>
                                                </tr>
                                            </template>
                                        </v-data-table>
                                    </v-flex>
                                </v-layout>
                                <v-flex lg6>
                                    <v-autocomplete outlined dense v-model="currentItem.UID" :items="customers"
                                        item-value="ID" item-text="Username" :label="$t('form.select_customer')" autocomplete="off"></v-autocomplete>
                                </v-flex>
                                <v-flex lg6>
                                    <v-autocomplete outlined dense v-model="currentItem.ProductType"
                                        :items="filteredProductTypes" item-value="ID" :item-text="(p) => {return `${p.ShortName} - ${p.Name}`}" :label="$t('form.product_type')"
                                        autocomplete="off"></v-autocomplete>
                                </v-flex>
                                <v-flex lg4>
                                    <h-currency-input :label="$t('table_headers.deposit')" v-model="currentItem.Deposit"
                                        :decimal="2" class="input-group--focused"></h-currency-input>
                                </v-flex>
                                <v-flex lg4>
                                    <h-currency-input :label="$t('form.exchange_rate')" v-model="currentItem.ExchangeRate" :decimal="0"
                                        class="input-group--focused"></h-currency-input>
                                </v-flex>
                                <v-flex lg4>
                                    <v-autocomplete outlined dense v-model="currentItem.PriceType" :items="price_types"
                                        item-value="value" item-text="name" :label="$t('form.price_type')" autocomplete="off"
                                        :disabled="!editableRole"></v-autocomplete>
                                </v-flex>
                                <v-flex lg4>
                                    <h-currency-input :label="$t('form.weight')" v-model="currentItem.Weight" :decimal="1"
                                        class="input-group--focused"></h-currency-input>
                                </v-flex>
                                <v-flex lg4>
                                    <h-currency-input :label="$t('form.volume')" v-model="currentItem.Volume" :decimal="3"
                                        class="input-group--focused"></h-currency-input>
                                </v-flex>
                                <v-flex lg4>
                                    <h-currency-input :label="$t('form.number_of_pack')" v-model="currentItem.NumberOfPack" :decimal="0"
                                        class="input-group--focused"></h-currency-input>
                                </v-flex>
                                <v-flex lg12>
                                    <v-text-field outlined dense :label="$t('form.note')"
                                        v-model="currentItem.Note"></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-form>
        </v-dialog>
        <upload-file :dialogUpload="dialogImport" title="Import mã vận đơn" temp_file="/ma_van_don_mau.xlsx"
            @closePopup="dialogImport = false" @importFile="importFile"></upload-file>

        <!-- Export Options Dialog -->
        <v-dialog v-model="dialogExport" max-width="500px">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t('dialog.select_export_type') }}</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-alert v-if="selectedItems && selectedItems.length > 0" color="info" text
                            icon="mdi-information" class="mb-3">
                            {{ $t('export.export_selected_items', { count: selectedItems.length }) }}
                        </v-alert>
                        <v-alert v-else color="warning" text icon="mdi-information" class="mb-3">
                            {{ $t('export.export_all_items') }}
                        </v-alert>
                        <v-radio-group v-model="selectedExportType">
                            <v-radio v-for="option in exportOptions" :key="option.value" :label="option.text"
                                :value="option.value"></v-radio>
                        </v-radio-group>
                        <v-checkbox v-if="selectedExportType === 'chinh_ngach_vi'" v-model="isSentCustoms" :label="$t('export.send_custom')"></v-checkbox>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" text @click="dialogExport = false">
                        {{ $t('actions.cancel') }}
                    </v-btn>
                    <v-btn color="primary" @click="confirmExport">
                        {{ $t('actions.export_file') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Quote Edit Dialog -->
        <v-dialog v-model="dialogQuoteEdit" max-width="700px" persistent>
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t('dialog.edit_quote_info') }}</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-form ref="quoteEditForm">
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="editingQuote.BrandName"
                                        :label="$t('form.product_brand')"
                                        outlined
                                        dense
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="editingQuote.ProductCapacity"
                                        :label="$t('form.product_capacity')"
                                        outlined
                                        dense
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="editingQuote.ProductMaterial"
                                        :label="$t('form.product_material')"
                                        outlined
                                        dense
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="editingQuote.PackType"
                                        :label="$t('form.pack_type')"
                                        outlined
                                        dense
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="editingQuote.ProductSize"
                                        :label="$t('form.product_size')"
                                        outlined
                                        dense
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model.number="editingQuote.ProductNumber"
                                        :label="$t('form.total_product')"
                                        outlined
                                        dense
                                        type="number"
                                        min="0"
                                        step="1"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn 
                        color="grey darken-1" 
                        text 
                        @click="cancelQuoteEdit"
                        :disabled="savingQuote"
                    >
                        {{ $t('actions.cancel') }}
                    </v-btn>
                    <v-btn 
                        color="primary" 
                        @click="saveQuoteEdit"
                        :loading="savingQuote"
                    >
                        {{ $t('actions.save') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import { mapState } from "vuex";
import configs from "@/configs";
import Filtering from "@/components/Filtering";
import { sendErrorNotice, sendSuccessNotice, makeid } from "@/commons/utils";
// import { print_quote_label } from "@/commons/hpod";
import upload_file from "@/components/popups/upload_file";
import createPermissionMixin from "@/mixins/permissionMixin";
import moment from 'moment';
import _ from "lodash";

export default {
    mixins: [createPermissionMixin('batch_package_all')],
    components: {
        "hpo-filter": Filtering,
        "upload-file": upload_file,
    },
    data() {
        return {
            viewName: "product_list",
            view_filters: [],
            dialogItem: false,
            dialogImport: false,
            dialogExport: false,
            dialogQuoteEdit: false,
            savingQuote: false,
            editingQuote: {
                ID: 0,
                BrandName: '',
                ProductCapacity: '',
                ProductMaterial: '',
                PackType: '',
                ProductSize: '',
                ProductNumber: 0
            },
            selectedExportType: 'tieu_ngach',
            isSentCustoms: 0,
            selectedItems: [],
            image_proxy: configs.IMAGE_PROXY,
            receive_type_list: configs.RECEIVE_TYPE_LIST,
            receive_type: configs.RECEIVE_TYPE,
            product_status_list: configs.PRODUCT_STATUS_LIST,
            product_status: configs.PRODUCT_STATUS,
            price_types: configs.PRICE_TYPE_LIST,
            sub_headers: [
                {
                    text: this.$t('form.suffix_bill'),
                    value: "TransactionCode",
                    sortable: false
                },
                {
                    text: this.$t('table_headers.length'),
                    value: "Length",
                    sortable: false,
                    align: "end",
                },
                {
                    text: this.$t('table_headers.width'),
                    value: "Width",
                    sortable: false,
                    align: "end",
                },
                {
                    text: this.$t('table_headers.height'),
                    value: "Height",
                    sortable: false,
                    align: "end",
                },
                {
                    text: this.$t('table_headers.weight'),
                    value: "Weight",
                    sortable: false,
                    align: "end",
                },
                {
                    text: this.$t('table_headers.number_of_pack'),
                    value: "NumberOfPack",
                    sortable: false,
                    align: "end",
                },
                {
                    text: "",
                    width: "40px",
                    align: "center",
                },
            ],
            pagination: { ...configs.PAGINATION },
            items_per_page: { ...configs.ITEMS_PER_PAGE },
            filterConditions: [],
            quickFilterConditions: [],
            requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
            receiveDate: null,
            packDate: null,
            deliverDate: null,
            paymentDate: null,
            files: [],
            uploading: 0,
            pendingUploads: [],
            currentPackages: [],
            availableQuotes: [],
            loadingQuotes: false,
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
        currentItem() {
            this.receiveDate = this.currentItem.ReceiveDate ? moment.utc(this.currentItem.ReceiveDate).format('YYYY-MM-DD') : null;
            this.packDate = this.currentItem.PackDate ? moment.utc(this.currentItem.PackDate).format('YYYY-MM-DD') : null;
            this.deliverDate = this.currentItem.DeliverDate ? moment.utc(this.currentItem.DeliverDate).format('YYYY-MM-DD') : null;
            this.paymentDate = this.currentItem.PaymentDate ? moment.utc(this.currentItem.PaymentDate).format('YYYY-MM-DD') : null;
            this.files = this.currentItem.Images ? JSON.parse(this.currentItem.Images) : [];
            this.currentPackages = this.currentItem && this.currentItem.Packages ? JSON.parse(this.currentItem.Packages) : [];
        },
        currentPath: function(val) {
            this.filter_data();
        },
        product_types() {
            let header_item = _.find(this.headers, { value: "ProductType" });
            if (header_item) {
                header_item.values =
                    _.map(this.product_types, (item) => {
                        return {
                            value: item.ID,
                            name: item.Name,
                        };
                    }) || [];
            }
        }
    },
    computed: {
        ...mapState({
            items: state => state.product.all.data,
            total_rows: state => state.product.all.total,
            summary: state => state.product.all.summary,
            loading: state => state.product.loading,
            currentItem: state => state.product.selected,
            customers: state => state.commons.customers,
            product_types: state => state.productType.all.data,
        }),
        filteredProductTypes() {
            if (!this.product_types) return [];
            return this.product_types.map(p => ({
                ...p,
                disabled: p.IsLocked == 1 || p.IsLocked == true
            }));
        },
        staffStorage() {
            return this.$store.state.authentication.user.storageid;
        },
        adminRole() {
            return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Admin;
        },
        editableRole() {
            return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Admin || this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Accountant;
        },
        roleStoreTQ() {
            return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Store;
        },
        roleCustomer() {
            return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Customer;
        },
        readOnly() {
            return this.currentItem && this.currentItem.ID > 0 && !(this.currentItem.Status == this.product_status.nhap_kho_tq);
        },
        currentPath() {
            return this.$route.path;
        },
        isNoneOwner() {
            return this.currentPath.includes('hang-khong-ten');
        },
        selectedItemsWeight() {
            return this.selectedItems.reduce((total, item) => total + (parseFloat(item.Weight) || 0), 0);
        },
        selectedItemsVolume() {
            return this.selectedItems.reduce((total, item) => total + (parseFloat(item.Volume) || 0), 0);
        },
        selectedItemsNumberOfPack() {
            return this.selectedItems.reduce((total, item) => total + (parseInt(item.NumberOfPack) || 0), 0);
        },
        headers() {
            let baseHeaders = [
                {
                    text: "Khách hàng / 唛头",
                    value: "CustomerCode",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Điều hướng / 目的地",
                    value: "DirectName",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Tên hàng / 货名",
                    value: "ProductNameVN",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: 'Mã hàng / 货号',
                    value: "Code",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: `${this.$t('table_headers.license_plate')} / 车牌号`,
                    value: "OrderCodes",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: `${this.$t('table_headers.bill_codes')} / 出货运单号`,
                    value: "BillCodes",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: this.currentPath.includes('ton-kho-tq') || this.currentPath.includes('ton-kho-vn')
                        ? `${this.$t('table_headers.remaining_pack')} / 件数`
                        : `${this.$t('table_headers.number_of_pack')} / 件数`,
                    value: "NumberOfPack",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: `${this.$t('table_headers.deposit')} / 总费用`,
                    value: "Deposit",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: 'Cân/khối / 重量/体积',
                    value: "Weight",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: `${this.$t('table_headers.total_fee_weight')} / 总重量费用`,
                    value: "TotalFeeWeight",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
            ];

            // Thêm các cột còn lại
            baseHeaders.push(
                {
                    text: `${this.$t('table_headers.receive_date')} / 入库日期`,
                    value: "ReceiveDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: `${this.$t('table_headers.deliver_date')} / 交货日期`,
                    value: "StoreCNExpDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: `${this.$t('table_headers.status')} / 状态`,
                    value: "Status",
                    filterable: true,
                    values: configs.PRODUCT_STATUS_LIST,
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: `${this.$t('table_headers.product_type')} / 货物类型`,
                    value: "ProductType",
                    filterable: true,
                    values: [],
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "",
                    value: "",
                    align: "center",
                    width: "80px"
                }
            );

            return baseHeaders;
        },
        filter_status() {
            return this.$route.meta && this.$route.meta.package_status ? this.$route.meta.package_status : [];
        },
        exportOptions() {
            return [
                { value: 'tieu_ngach', text: this.$t('form.export_tieu_ngach') },
                { value: 'chinh_ngach', text: this.$t('form.export_chinh_ngach') },
                { value: 'chinh_ngach_vi', text: this.$t('form.export_chinh_ngach_vi') },
            ];
        },
        filter_header() {
            let tmp = [...this.headers];
            tmp.push({
                text: this.$t('export.send_custom'),
                value: "IsSentCustoms",
                filterable: true,
                values: [{ value: 1, name: 'Yes' }, { value: 0, name: 'No' }],
                dataType: configs.DATA_TYPE["Enum"]
            });
            return tmp;
        }
    },
    methods: {
        changeStatusSelectedProducts() {
            if (!this.selectedItems || this.selectedItems.length === 0) {
                sendErrorNotice('Vui lòng chọn sản phẩm để chuyển trạng thái!');
                return;
            }
            // Ví dụ: chuyển trạng thái sang "Đã giao" (Status = 3)
            const ids = this.selectedItems.map(item => item.ID);
            // Có thể mở dialog chọn trạng thái, ở đây demo cứng Status = 3
            // nhap_kho_tq: 1,
            // cho_xep_xe: 2,
            // xep_xe: 3,
            // cho_thong_quan_tq: 4,
            // kiem_hoa: 5,
            // cho_thong_quan_vn: 6,
            // nhap_kho_vn: 7,
            // xuat_thieu: 8,
            // xuat_du: 9
            let nextStatus = this.product_status.nhap_kho_tq;
            const payload = { ids, Status: nextStatus };
            this.$store.dispatch("product/setDetail", { data: payload, id: ids[0] })
                .then(() => {
                    // this.selectedItems = [];
                    sendSuccessNotice('Chuyển trạng thái thành công!');
                })
                .catch(() => {
                    sendErrorNotice('Có lỗi khi chuyển trạng thái!');
                });
        },
        filter_data: function () {
            var param = {
                pagination: this.pagination,
                filter: [...this.filterConditions],
                quickFilter: [...this.quickFilterConditions]
            };
            if (this.isNoneOwner) {
                param.filter.push({
                    column: "CustomerCode",
                    value: "MKH",
                    condition: "s_equal",
                });
                param.action = "hang-khong-ten";
            }
            if (this.filter_status && this.filter_status.length > 0) {
                param.filter.push({
                    column: "Status",
                    value: this.filter_status,
                    condition: "in",
                });
            }
            if (this.currentPath.includes('ton-kho-tq')) {
                param.action = "ton-kho-tq";
            }
            else if (this.currentPath.includes('ton-kho-vn')) {
                param.action = "ton-kho-vn";
            }
            this.$store.dispatch("product/getList", param);
            if (this.dialogItem && this.currentItem.ID > 0) {
                this.$store.dispatch("product/getDetail", this.currentItem.ID);
            }
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        printLabel(quote_id) {
            // this.$store.dispatch("quote/getDetail", quote_id).then((quoteItem) => {
            //     print_quote_label(quoteItem);
            // });
        },
        editQuote(quoteId) {
            if (!quoteId || quoteId <= 0) {
                sendErrorNotice(this.$t('errors.product_no_quote'));
                return;
            }
            
            // Load thông tin báo giá từ API
            this.$store.dispatch("quote/getDetail", quoteId).then((quoteItem) => {
                this.editingQuote = {
                    ID: quoteItem.ID || quoteId,
                    BrandName: quoteItem.BrandName || '',
                    ProductCapacity: quoteItem.ProductCapacity || '',
                    ProductMaterial: quoteItem.ProductMaterial || '',
                    PackType: quoteItem.PackType || '',
                    ProductSize: quoteItem.ProductSize || '',
                    ProductNumber: quoteItem.ProductNumber || 0
                };
                this.dialogQuoteEdit = true;
            }).catch(error => {
                console.error('Error loading quote:', error);
                sendErrorNotice(this.$t('errors.cannot_load_quote_info'));
            });
        },
        cancelQuoteEdit() {
            this.dialogQuoteEdit = false;
            this.resetEditingQuote();
        },
        resetEditingQuote() {
            this.editingQuote = {
                ID: 0,
                BrandName: '',
                ProductCapacity: '',
                ProductMaterial: '',
                PackType: '',
                ProductSize: '',
                ProductNumber: 0
            };
        },
        async saveQuoteEdit() {
            if (!this.$refs.quoteEditForm.validate()) {
                return;
            }
            
            this.savingQuote = true;
            
            try {
                const updateData = {
                    BrandName: this.editingQuote.BrandName,
                    ProductCapacity: this.editingQuote.ProductCapacity,
                    ProductMaterial: this.editingQuote.ProductMaterial,
                    PackType: this.editingQuote.PackType,
                    ProductSize: this.editingQuote.ProductSize,
                    ProductNumber: this.editingQuote.ProductNumber
                };
                
                await this.$store.dispatch("quote/setDetail", {
                    data: updateData,
                    id: this.editingQuote.ID
                });
                
                sendSuccessNotice(this.$t('success.quote_updated'));
                this.dialogQuoteEdit = false;
                this.resetEditingQuote();
                
                // Refresh danh sách sản phẩm để hiển thị thông tin mới
                this.filter_data();
                
            } catch (error) {
                console.error('Error updating quote:', error);
                sendErrorNotice(this.$t('errors.cannot_update_quote'));
            } finally {
                this.savingQuote = false;
            }
        },
        openItem: function (id) {
            this.$router.push({
                name: "ProductDetail",
                params: { Pid: id || 'new', title: `Chi tiết mã bốc (#${id || 'mới'})` }
            });
        },
        deleteItem: function (id) {
            window.getApp.$emit('REQUEST_DELETE_DATA', id);
        },
        saveItem(item, status) {
            if(!(this.editableRole || status < this.product_status.da_xuat_kho)) {
                sendErrorNotice("Bạn không có quyền chỉnh sửa mã bốc này");
                return;
            }
            this.$store.dispatch("product/setDetail", { data: item, id: item.ID });
        },
        async editItem() {
            if (this.$refs.edit_form.validate()) {
                await this.uploadPendingFiles();
                let selectedCustomer = _.find(this.customers, { 'ID': this.currentItem.UID });
                let uniqueFiles = [];
                let fileNames = new Set();
                for (const f of this.files) {
                    if (!fileNames.has(f.name)) {
                        uniqueFiles.push(f);
                        fileNames.add(f.name);
                    }
                }
                // Loại bỏ phần tử khỏi currentPackages có TransactionCode rỗng
                this.currentPackages = this.currentPackages.filter(pkg => pkg.TransactionCode || pkg.Length || pkg.Width || pkg.Height || pkg.Weight || pkg.NumberOfPack);
                this.$store.dispatch("product/setDetail", {
                    'data': {
                        ...this.currentItem,
                        Packages: this.currentPackages.length > 0 ? JSON.stringify(this.currentPackages) : null,
                        ReceiveDate: this.receiveDate ? moment.utc(this.receiveDate).format(configs.SQL_DATE_FORMAT) : null,
                        PackDate: this.packDate ? moment.utc(this.packDate).format(configs.SQL_DATE_FORMAT) : null,
                        DeliverDate: this.deliverDate ? moment.utc(this.deliverDate).format(configs.SQL_DATE_FORMAT) : null,
                        PaymentDate: this.paymentDate ? moment.utc(this.paymentDate).format(configs.SQL_DATE_FORMAT) : null,
                        UserName: selectedCustomer ? selectedCustomer.Username : this.currentItem.Username,
                        Status: this.currentItem.ID > 0 ? this.currentItem.Status : this.product_status.nhap_kho_tq,
                        Images: JSON.stringify(uniqueFiles),
                    },
                    'id': this.currentItem.ID || 0
                }).then(() => {
                    if(this.currentItem.TruckID) {
                        this.$store.dispatch("order/setDetail", { data: { ModifiedBy: this.currentItem.ModifiedBy }, id: this.currentItem.TruckID });
                    }
                });
                this.dialogItem = false;
                this.pendingUploads = [];
            }
        },
        addSubItem() {
            // if(!this.currentItem.ID) {
            //     sendErrorNotice(this.$t('form.notice_save_product'));
            //     return;
            // }
            let split_packages = [...this.currentPackages];
            split_packages.push({ 'Length': 0, 'Width': 0, 'Height': 0, 'Weight': 0, 'NumberOfPack': 0 });
            this.currentItem.Packages = JSON.stringify(split_packages);
            this.currentPackages = this.currentItem && this.currentItem.Packages ? JSON.parse(this.currentItem.Packages) : [];
            if (this.currentItem.ID > 0) {
                this.$store.dispatch("product/setDetail", {
                    data: {
                        Packages: this.currentItem.Packages,
                    },
                    id: this.currentItem.ID,
                });
            }
        },
        deleteSubItem(index) {
            let split_packages = [...this.currentPackages];
            split_packages.splice(index, 1);
            this.currentItem.Packages = JSON.stringify(split_packages);
            this.currentPackages = this.currentItem && this.currentItem.Packages ? JSON.parse(this.currentItem.Packages) : [];
            if (this.currentItem.ID > 0) {
                this.$store.dispatch("product/setDetail", {
                    data: {
                        Packages: this.currentItem.Packages,
                    },
                    id: this.currentItem.ID,
                });
            }
        },
        updateSubItem(isAddSub = false) {
            if (isAddSub) {
                this.addSubItem();
                return;
            }
            this.currentItem.Packages = JSON.stringify(this.currentPackages);
            if (this.currentItem.ID > 0) {
                this.$store.dispatch("product/setDetail", {
                    data: {
                        Packages: this.currentItem.Packages,
                    },
                    id: this.currentItem.ID,
                });
            }
        },
        fileOpen(f) {
            window.open(this.image_proxy + encodeURIComponent(f.url), 'blank');
        },
        async fileRemove(index) {
            const fileToRemove = this.files[index];

            // Nếu file có path (đã upload lên Firebase), xóa từ server
            if (fileToRemove.path) {
                try {
                    const fileUploadService = (await import('@/services/fileUploadService')).default;
                    const result = await fileUploadService.deleteFile(fileToRemove.path);

                    if (!result.success) {
                        console.error('Error deleting file:', result.message);
                        // Vẫn xóa khỏi UI dù có lỗi từ server
                    }
                } catch (error) {
                    console.error('Delete file error:', error);
                }
            }

            // Xóa khỏi danh sách hiển thị
            this.files.splice(index, 1);
        },
        uploadFile(e) {
            const file = e.target.files[0];
            this.pendingUploads.push(file);
            this.files.push({ 'local': 1, 'name': file.name, 'url': URL.createObjectURL(file) });
            this.$refs.fileInput.value = null;
        },
        timer(ms) { return new Promise(res => setTimeout(res, ms)); },
        async uploadPendingFiles() {
            this.files = _.filter(this.files, (p) => { return p.local !== 1 });
            this.uploading = this.pendingUploads.length;

            // Import file upload service
            const fileUploadService = (await import('@/services/fileUploadService')).default;

            for (let index = 0; index < this.pendingUploads.length; index++) {
                const file = this.pendingUploads[index];

                // Validate file using service
                const validation = fileUploadService.validateFile(file, ['jpg', 'jpeg', 'png', 'gif'], 10);
                if (!validation.valid) {
                    sendErrorNotice(validation.message);
                    this.uploading = this.uploading - 1;
                    continue;
                }

                try {
                    // Upload through backend proxy
                    const result = await fileUploadService.uploadSingleFile(file, 'bill');

                    if (result.success) {
                        this.files.push({
                            'name': result.data.name,
                            'url': result.data.url,
                            'path': result.data.path,
                            'size': result.data.size
                        });
                    } else {
                        sendErrorNotice(result.message);
                    }
                } catch (error) {
                    console.error('Upload error:', error);
                    sendErrorNotice('Lỗi upload file!');
                }

                this.uploading = this.uploading - 1;
            }
        },
        importFileDialog() {
            this.dialogImport = true;
        },
        importFile(filelist) {
            for (const f of filelist) {
                const formData = new FormData();
                formData.append('excel_file', f);
                formData.append('filename', f.name);
                this.$store.dispatch("product/import_data", formData);
            }
            this.dialogImport = false;
        },
        exportData() {
            // Show export options dialog
            this.dialogExport = true;
        },
        exportSelectedItems() {
            if (!this.selectedItems || this.selectedItems.length === 0) {
                sendErrorNotice('Vui lòng chọn ít nhất một sản phẩm để xuất Excel!');
                return;
            }
            // Show export options dialog cho selected items
            this.dialogExport = true;
        },
        confirmExport() {
            var param = {
                exportType: this.selectedExportType
            };

            const hasSelectedItems = this.selectedItems && this.selectedItems.length > 0;

            // Nếu có selected items thì export theo selection, ngược lại export theo filter
            if (hasSelectedItems) {
                // Export theo selected items
                param.selectedIds = this.selectedItems.map(item => item.ID);
            } else {
                // Export theo filter như cũ
                param.pagination = this.pagination;
                param.filter = this.filterConditions;
                param.quickFilter = this.quickFilterConditions;
            }

            param.isSentCustoms = this.isSentCustoms ? 1 : 0;

            this.dialogExport = false;

            // Choose the appropriate export function based on selection
            const exportPromise = this.selectedExportType === 'tieu_ngach'
                ? this.$store.dispatch("product/exportTieuNgach", param) : this.selectedExportType === 'chinh_ngach' ?
                    this.$store.dispatch("product/exportChinhNgach", param)
                : this.$store.dispatch("product/exportChinhNgachVi", param);

            // exportPromise.then(() => {
            //     // Clear selection sau khi export thành công
            //     if (hasSelectedItems) {
            //         this.selectedItems = [];
            //         this.filter_data();
            //     }
            // }).catch(error => {
            //     console.error('Export error:', error);
            // });
        },
    },
    mounted() {
        // this.$root.$emit('REQUEST_ROOT_OPTION', { invisibleCreateButton: !this.editableRole, invisibleImportButton: !this.editableRole });
        this.$root.$emit('REQUEST_ROOT_OPTION', { });
        this.$store.dispatch("commons/getAllCustomer");
        this.$store.dispatch("productType/getList");
        this.$root.$on("REQUEST_CREATE_DATA", this.openItem);
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$on("REQUEST_IMPORT_ACTION", this.importFileDialog);
        this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
            this.$store.dispatch("product/removeDetail", id);
        });
        this.$root.$on("REQUEST_EXPORT_ACTION", this.exportData);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_CREATE_DATA");
        this.$root.$off("REQUEST_REFRESH_DATA");
        this.$root.$off("CONFIRMED_REMOVE_DATA");
        this.$root.$off("REQUEST_IMPORT_ACTION");
        this.$root.$off("REQUEST_EXPORT_ACTION");
    }
};
</script>
<style scoped>
.thumbnail-img {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    transition: box-shadow 0.2s;
}

.thumbnail-img:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
}
</style>